import { combineReducers, AnyAction } from '@reduxjs/toolkit';

import authSlice from './authSlice';
import manufactureSlice from './manufacturerSlice';
import commonSlice from './commonSlice';
import weightUnitSlice from './weightUnitSlice';
import categorySlice from './categorySlice';
import productSlice from './productSlice';
import currencySlice from './currecnySlice';
import orderSlice from './orderSlice';
import customerSlice from './customerSlice';

const reducers = combineReducers({
  auth: authSlice,
  manufacturer: manufactureSlice,
  common: commonSlice,
  weightUnit: weightUnitSlice,
  category: categorySlice,
  product: productSlice,
  currency: currencySlice,
  order: orderSlice,
  customer: customerSlice,
});

const rootReducer = (state: ReturnType<typeof reducers> | undefined, action: AnyAction) => {
  //clear state on logut
  if (action.type == 'auth/logut') {
    //return config state as is, and all other state will be undefined
    //state= undefined
  }
  return reducers(state, action);
};

export default rootReducer;
